import React, { useRef, useState, useEffect } from 'react';

const Carousel = ({ images = [] }) => {
    const scrollRef = useRef(null);
    const [selectedImg, setSelectedImg] = useState(null);

    // États pour la barre de progression
    const [scrollProgress, setScrollProgress] = useState(0); // Position du scroll en %
    const [thumbWidth, setThumbWidth] = useState(33); // Largeur du curseur en %

    // Fonction pour calculer la progression
    const handleScroll = () => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

            // Calcul du pourcentage de progression
            // (Position actuelle / Espace total défilable) * 100
            const totalScrollable = scrollWidth - clientWidth;
            const progress = totalScrollable > 0 ? (scrollLeft / totalScrollable) * 100 : 0;

            setScrollProgress(progress);
        }
    };

    // Calculer la largeur initiale du curseur (optionnel, pour plus de précision)
    useEffect(() => {
        if (scrollRef.current) {
            const { scrollWidth, clientWidth } = scrollRef.current;
            // La largeur du curseur représente la proportion visible du contenu
            const width = (clientWidth / scrollWidth) * 100;
            setThumbWidth(width);
        }
    }, [images]);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const { clientWidth } = scrollRef.current;
            const scrollTo = direction === 'left'
                ? scrollRef.current.scrollLeft - clientWidth
                : scrollRef.current.scrollLeft + clientWidth;

            scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
    };

    return (
        <div className="relative w-full group">
            {/* --- LIGHTBOX (Zoom) --- */}
            {selectedImg && (
                <div
                    className="fixed inset-0 z-[100] flex items-center justify-center bg-[#1A1A1A]/90 backdrop-blur-sm cursor-zoom-out p-4 md:p-10"
                    onClick={() => setSelectedImg(null)}
                >
                    <button className="absolute top-10 right-10 text-[#F3F0E9] hover:rotate-90 transition-transform">
                        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <img src={selectedImg} alt="Zoom" className="max-w-full max-h-full object-contain animate-in zoom-in duration-300" />
                </div>
            )}

            {/* --- CAROUSEL --- */}
            <div
                ref={scrollRef}
                onScroll={handleScroll} // ON ÉCOUTE LE SCROLL ICI
                className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4 md:gap-6 pb-4"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
                {images.map((img, index) => (
                    <div key={index} className="min-w-full md:min-w-[calc(33.333%-1rem)] snap-center">
                        <div
                            className="aspect-square md:aspect-[4/5] bg-neutral-200 overflow-hidden shadow-sm cursor-zoom-in"
                            onClick={() => setSelectedImg(img)}
                        >
                            <img src={img} alt={`Slide ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 hover:scale-110" />
                        </div>
                    </div>
                ))}
            </div>

            {/* Boutons Navigation */}
            <button onClick={() => scroll('left')} className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-[#F3F0E9]/80 backdrop-blur-sm p-3 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
                <svg className="w-5 h-5 text-[#1A1A1A]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" /></svg>
            </button>
            <button onClick={() => scroll('right')} className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-[#F3F0E9]/80 backdrop-blur-sm p-3 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
                <svg className="w-5 h-5 text-[#1A1A1A]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" /></svg>
            </button>

            {/* --- BARRE DE PROGRESSION DYNAMIQUE --- */}
            <div className="flex justify-center mt-8">
                <div className="w-32 h-1 bg-[#1A1A1A]/10 rounded-full relative">
                    <div
                        className="absolute top-0 h-full bg-[#B4A782] rounded-full transition-all duration-150 ease-out"
                        style={{
                            width: `${thumbWidth}%`,
                            // On déplace le curseur en fonction du scroll
                            left: `${(scrollProgress * (100 - thumbWidth)) / 100}%`
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default Carousel;